import axios from 'axios';

export const TalonRegistrationApi = {
  loadTableData: filter =>
    axios.get(`api/public/info/paging/service_provider/notifications?filter=${filter}`),
  loadById: id => axios.get(`api/public/info/service_provider/notify/${id}`),
  getSignString: params =>
    axios.post(`api/info/signature/sign_string/service_provider/coupon`, params),
  register: params => axios.post(`api/public/service_provider/coupon/register`, params)
};
